import $ from 'jquery';
import Web3EthPersonal from 'web3-eth-personal';
import showAlert from './showAlert';
import { getToken } from './login.js';

const login = async () => {
  const swal = showAlert({
    title: 'Signature request',
    message: 'Please continue the Metamask process!',
    icon: 'wait',
  });

  const accounts = await web3Client.eth.getAccounts();

  const sessionKey = window.sessionStorage.getItem('sessionKey');
  const token = getToken();
  if (sessionKey) {
    await $.post('/api/wallet/session', `session=${sessionKey}&address=${accounts[0]}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, (data) => {
      if (data.success) {
        window.sessionKey = sessionKey;
        window.token = token;
      } else {
        window.sessionStorage.removeItem('sessionKey');
        window.localStorage.removeItem('token');
      }
    });
  }

  if (window.sessionKey) {
    swal.close();
    return true;
  }

  const response = await fetch('/api/wallet/nonce', {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'post',
    authorization: true,
    body: JSON.stringify({
      address: accounts[0],
      chainId: window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId,
    }),
  }).then(res => res.json());
  const personal = new Web3EthPersonal(ethereum);

  try {
    const signature = await personal.sign(web3Client.utils.toHex(`Sign to Login. Nonce: ${response.nonce}`), accounts[0]);

    swal.close();

    const wallet = await fetch('/api/wallet/login', {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'post',
      authorization: true,
      body: JSON.stringify({
        nonce: response.nonce,
        signature,
        address: accounts[0],
        chainId: window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId,
      }),
    }).then(res => res.json());

    if (wallet.success) {
      window.localStorage.setItem('token', wallet.token);
      window.sessionStorage.setItem('sessionKey', wallet.session_key);
      window.sessionKey = wallet.session_key;

      if (wallet.code === 'email_not_verified') {
        window.location.href = '/verify-email';
        return true;
      }

      return true;
    }

    showAlert({ message: $(wallet.message ? wallet.message : 'Login operation failed, please try again'), icon: 'error' });
  } catch (error) {
    showAlert({ message: error.message, icon: 'error' });
  }


  return false;
};

export default login;
